<template>
  <div class="modal">
    <div class="content">
      <div class="bulk-targets">
        <h1>{{ parseTranslation(TITLE) }}</h1>
      </div>

      <div>
        <strong>{{ parseTranslation(LABEL) }} </strong>

        <span>"{{ alternative.label }}"</span>
      </div>

      <div class="options-wrapper">
        <div v-for="alternativeOption in optionsToRender" :key="alternativeOption">
          <component
            :is="getComponent(alternativeOption)"
            :id="
              `question-${question_index}-group-${questions_groups_index}-alternative-${alternativeOption}`
            "
            :question_index="question_index"
            :questions_groups_index="questions_groups_index"
            :updateAlternative="updateAlternative"
            :alternative="alternative"
            :option="alternativeOption"
          />
        </div>
      </div>

      <div class="buttons">
        <button @click="close">{{ parseTranslation(CLOSE) }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { alternativesRenderConfig } from '@/utils/alternativeOptions'

import * as translationBulkAddAndEditModal from './index.translations'

import RenderFlow from './RenderFlow'
import LeftRightImage from './LeftRightImage'

const { default: translations, ...translationKeys } = translationBulkAddAndEditModal

const components = {
  onlyRenderWhen: 'RenderFlow',
  rightImage: 'LeftRightImage',
  leftImage: 'LeftRightImage',
}

export default {
  name: 'ExtraOptionsModal',

  components: {
    RenderFlow,
    LeftRightImage,
  },

  props: {
    close: {
      required: true,
      type: Function,
    },

    updateAlternative: {
      required: true,
      type: Function,
    },

    questions_groups_index: {
      required: true,
      type: Number,
    },

    question_index: {
      required: true,
      type: Number,
    },

    property: {
      required: true,
      type: String,
    },

    alternative: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
    }
  },

  computed: {
    ...mapState(['questionGroups']),

    question() {
      return this.questionGroups[this.questions_groups_index].questions[
        this.question_index
      ]
    },

    optionsToRender() {
      return Object.keys(alternativesRenderConfig).filter(option =>
        alternativesRenderConfig[option].renderChecker(
          this.question,
          this.property,
          this.questionGroups,
        ),
      )
    },
  },

  methods: {
    getComponent(option) {
      const component = components[option]

      if (component) return component

      return console.error(`Custom component for ${option} not found`)
    },
  },
}
</script>

<style lang="scss" scoped>
h1 {
  color: $blue-2;
  font-size: rem(22);
  font-weight: 600;
}

.options-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
}

.content {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  max-height: 85vh;
  overflow: auto;

  .light & {
    color: $gray-14;
  }
}

.modal {
  @include background-modal-config;
  display: flex;

  > div {
    @include tipography(16);
    padding: 20px;
    border-radius: 3px;
    position: fixed;
    width: MIN(90vw, 700px);
    background: $gray-7;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;

    .buttons {
      @include flexMiddle;

      button {
        @include transparentButton;
        @include tipography(16);
        background: $blue;
        border: 1px solid $blue;
        border-radius: 3px;
        padding: 5px 10px;
        width: 85px;

        &:first-of-type {
          border: 1px solid $blue;
          color: $blue;
          background: transparent;
        }

        &:hover {
          transform: scale(1.01);
        }
      }
    }

    .light & {
      background: $white;
    }
  }
}
</style>
